import { InjectionToken } from '@angular/core';
import { MojoTalentPoolsService } from 'mojo-talent-pools';

export const TALENT_POOLS_SERVICE = new InjectionToken<MojoTalentPoolsService>(
  'MojoTalentPoolsService',
);
